const traducciones = {
  '¡Transformamos tu financiera desde el Core!': 'We transform your financial institution from the core!',
  'El Core Bancario que te ayuda a automatizar procesos y gestionar productos financieros digitales.': 'The banking core that helps you automate processes and manage digital financial products.',
  'Términos y condiciones':'Terms and Conditions',
  'Aviso de privacidad':'Privacy Notice',
  'Administracion de clientes':'Customer administration',
  'Análisis de crédito':'Credit analysis',
  'Administración de Productos':'Product Management',
  'Automatización de Operaciones':'Operations Automation',
  'Dispersión':'Dispersion',
  'Cobranza':'Payments',
  'Amplia tu oferta':'Expand your offer',
  'Reportes':'Reports',
};

export default traducciones;
